module.exports = __webpack_public_path__ + "img/creepy-santa.96fa260a.jpg";